export const YOUTUBE_KEY = 'AIzaSyAk_qdlzjXcPJSviDvX2UqjhYthUlYNvBU'
export const YOUTUBE_URL = 'https://www.googleapis.com/youtube/v3/videos'

export const GOOGLE_ANALYTICS_KEY = 'G-8Z6EV88KCJ'

export const PRODUCT_MAP:any = {
  'https://www.fwd.com.hk/online-insurance/vhis-vprime-medical-plan/': {
    id: 'ecom14',
    name: 'vprime',
    category: 'medical',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/products/car-boat/motor-smart-plus/': {
    id: 'ecom04',
    name: 'motorsmart',
    category: 'vehicle',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/online-insurance/mymillion-medical/': {
    id: 'ecom15',
    name: 'mymillion',
    category: 'medical',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/products/travel-golf/travel-care-insurance/': {
    id: 'ecom12',
    name: 'travel',
    category: 'travel',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/online-insurance/term-critical-illness/': {
    id: 'ecom08',
    name: 'mycover',
    category: 'medical',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/online-insurance/term-life/': {
    id: 'ecom01',
    name: 'myterm life',
    category: 'life',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/products/household-pets/easy-home-care/': {
    id: 'ecom10',
    name: 'easyhomecare',
    category: 'household',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/online-insurance/mysafe-accident-protection-plan/': {
    id: 'ecom09',
    name: 'mysafe',
    category: 'accident',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/online-insurance/vhis-vcare-medical-plan/': {
    id: 'ecom06',
    name: 'vcare',
    category: 'medical',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/products/household-pets/home-care-insurance/': {
    id: 'ecom03',
    name: 'homecare',
    category: 'household',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/online-insurance/cancer-cansurance/': {
    id: 'ecom02',
    name: 'cansurance',
    category: 'medical',
    brand: 'FWD'
  },
  'https://www.fwd.com.hk/products/helper/helper-care-insurance/': {
    id: 'ecom11',
    name: 'helpercare',
    category: 'household',
    brand: 'FWD'
  }
}

export const KEY = '22fb93f6-93c1-480a-99bd-b598ae91051d'